import { z } from 'zod';

import { WithRequired } from '~/lib/@types/helpers';
import { modelAllPosts, modelPost } from '~/lib/api/models';

export const getMainPostCategory = (
  post: WithRequired<
    Partial<z.infer<typeof modelPost.schema>['post']>,
    'categories'
  >
):
  | z.infer<
      typeof modelPost.schema
    >['post']['categories']['edges'][number]['node']
  | undefined => {
  const mainCategory = post.categories.edges.at(0);

  return mainCategory?.node;
};

export const getMainPostCategorySlug = (
  post:
    | z.infer<typeof modelPost.schema>['post']
    | z.infer<typeof modelAllPosts.schema>['posts']['edges'][number]['node']
): string | undefined => {
  const mainCategory = post.categories.edges.at(0);

  return mainCategory?.node.slug;
};
